import { c as _c } from "react/compiler-runtime";
import type * as React from "react";
import { cn } from "../shared/cn";

/**
 * A `code` element that only looks interactive once the page is hydrated, i.e.
 * when `<body>` carries the `js` class (see the `js` variant in global.css).
 */
export function ClickableCode(t0) {
  const $ = _c(8);
  let className;
  let rest;
  if ($[0] !== t0) {
    ({
      className,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
  } else {
    className = $[1];
    rest = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("border-b border-dotted border-transparent js:cursor-pointer js:border-border js:active:bg-border", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== rest || $[6] !== t1) {
    t2 = <code className={t1} {...rest} />;
    $[5] = rest;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}